// extracted by mini-css-extract-plugin
export default {"container":"AdminEnterName_container__2SnyU","error__text":"AdminEnterName_error__text__ZuOtm"};